export const MOCK_ADVISORLIST_RESPONSE = {
    'errorCode': 0,
    'errorDescription': 'SUCCESS',
    'errorMessage': null,
    'response': {
        'data': [{
            'partyId': '468917615446135643',
            'alternateId': '9TMK0ERIC',
            'type': {
                'code': 'I',
                'description': 'INDIVIDUAL'
            },
            'role': {
                'code': '080',
                'description': 'Advisor'
            },
            'addressList': [],
            'emailList': [],
            'phoneList': [],
            'hasNonCustody': true,
            'fullName': 'ERIC',
            'links': []
        }, {
            'partyId': '180917615446011055',
            'alternateId': '9TOH0NW12',
            'type': {
                'code': 'I',
                'description': 'INDIVIDUAL'
            },
            'role': {
                'code': '080',
                'description': 'Advisor'
            },
            'addressList': [{
                'addressType': {
                    'code': 'M',
                    'description': 'MAILING'
                },
                'line1': '610 LAKESIDE DRIVE',
                'line2': null,
                'line3': null,
                'line4': null,
                'line5': null,
                'line6': null,
                'countryCode': null,
                'city': null,
                'stateCode': null,
                'zipCode': null
            }],
            'emailList': [],
            'phoneList': [],
            'hasNonCustody': true,
            'fullName': 'GARY',
            'links': []
        }],
        'paging': {
            'totalPages': 1,
            'currentPage': 1,
            'pageSize': 1,
            'totalRecords': 0,
            'totalRecordsOnPage': 0,
            'links': [{
                'rel': 'self',
                'href': '/dev-netx-advisor-service-api/',
                'hreflang': null,
                'media': null,
                'title': null,
                'type': null,
                'deprecation': null
            }, {
                'rel': 'first',
                'href': '/dev-netx-advisor-service-api/',
                'hreflang': null,
                'media': null,
                'title': null,
                'type': null,
                'deprecation': null
            }, {
                'rel': 'last',
                'href': '/dev-netx-advisor-service-api/',
                'hreflang': null,
                'media': null,
                'title': null,
                'type': null,
                'deprecation': null
            }]
        }
    }
};
